var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center p-5"},[_c('div',{staticClass:"empty-list-container",style:(("background-size: " + _vm.size))}),_c('div',{staticClass:"text-gray-500 text-lg mt-2"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }